import React, { useContext, useMemo, useRef, useState } from 'react';
import { Button } from 'antd';
import CelebrationHatch from '../cb-hatch/CelebrationHatch';
import { AuthContext } from './auth/AuthProvider';

const CELEBRATION_CONFIG_ID = 'a09d33a3-8445-4c4a-b2f6-6a45a31f9b20';
// const CELEBRATION_CONFIG_ID = 'f73fe322-72f0-45a3-99d4-7b64c72cf788';
//"6324dc0e-22fc-4f3f-bfa1-6453d62968b5"
//Gold comnpany config id

const Wrapper = ( props ) => {
    const ref = useRef();
    const [ celebrationConfigId ] = useState( CELEBRATION_CONFIG_ID );


    const handleDeleteRewardCallback = () => {
        console.log( 'Delete reward clicked' );
    };

    const authState = useContext( AuthContext );

    const authToken = useMemo( () => {
        return authState.auth?.access_token || '';
    }, [ authState.auth?.access_token ] );

    const companyId = useMemo( () => {
        return authState.auth?.claims.company_id || '';
    }, [ authState.auth?.claims.company_id ] );

    const handleClick = () => {
        console.log( 'Save Clicked' );

        const result = ref.current.saveCelebration();

        result.then( ( value ) => {
            console.log( value );
        } );
    };

    return (
        <div>


            { authToken &&
                <>
                    <CelebrationHatch
                        ref={ ref }
                        user={ authState.auth }
                        celebrationConfigId={ celebrationConfigId }
                        deleteCelebrationStack={ handleDeleteRewardCallback }
                        companyConfigId={ companyId }
                    />
                    <br />
                    <Button style={ { margin: '10px' } } onClick={ handleClick }>
                        Save
                    </Button>

                </>
            }

        </div>
    );
};

export default Wrapper;
